import { render, staticRenderFns } from "./RequestStatusDetail.vue?vue&type=template&id=3c04543e&scoped=true"
import script from "./RequestStatusDetail.vue?vue&type=script&lang=js"
export * from "./RequestStatusDetail.vue?vue&type=script&lang=js"
import style0 from "./RequestStatusDetail.vue?vue&type=style&index=0&id=3c04543e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c04543e",
  null
  
)

export default component.exports